<template>
  <div id="page-login" class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center">
    <div class="vx-col">
      <div class="w-full text-center" style="margin-bottom: 54px">
        <img :src="loginTopImage" alt="login" style="width: 100%; max-width: 480px; max-height: 240px" />
      </div>
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center grid grid-cols-7 md:grid-cols-12" style="max-width: 1150px">
            <!--              style="display: grid; grid-template-columns: 550px 620px; grid-template-rows: 400px;">-->
            <div class="vx-col hidden md:block col-span-6" style="height: 500px; width: 550px">
              <img :src="loginLeftImage" style="width: 100%; height: 100%; object-fit: cover" alt="login" class="mx-auto" />
            </div>
            <div class="vx-col h-full w-full d-theme-dark-bg col-span-6" style="padding: 40px 0px">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">로그인</h4>
                  <p>아이디와 비밀번호를 입력해주세요.</p>
                </div>

                <div class="pt-1">
                  <ml-input name="email" icon-no-border icon="icon icon-user" icon-pack="feather" label-placeholder="아이디 입력" v-model="emailInput" class="w-full" />

                  <ml-input type="password" name="password" icon-no-border icon="icon icon-lock" icon-pack="feather" label-placeholder="비밀번호 입력" v-model="passwordInput" class="w-full mt-6" @keyup.enter="login" />

                  <div class="flex flex-wrap justify-between my-5">
                    <vs-checkbox v-model="checkbox_remember_me" class="mb-3">아이디 기억하기</vs-checkbox>
                    <!--                    <router-link to="/forgot-password">비밀번호를 잊으셨나요?</router-link>-->
                  </div>
                  <!--
                  # 자동방지문자 : google
                  -->

                  <vue-recaptcha v-if="recaptcha" class="mb-8" ref="recaptcha" @expired="onExpired" @render="cargarCaptchar = true" @error="recaptchar = false" @verify="onVerify" sitekey="6LdUVN0aAAAAAH3ks4Ji-iuhmZ00-Af6W9xhxZGU" />

                  <vs-button v-if="isLoginInProgress" class="float-right" color="secondary" disabled>잠시만 기다려주세요</vs-button>
                  <vs-button v-else class="float-right" color="secondary" @click="login">로그인</vs-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import config from "/public/config";
import VueCookie from "vue-cookie";
import constant from "@/constant/constant";
import VueRecaptcha from "vue-recaptcha";
import * as UiUtil from "@/util/UiUtil";

export default {
  components: {
    VueRecaptcha,
  },
  watch: {
    checkbox_remember_me(checkbox_remember_me) {
      this.checkbox_remember_me = checkbox_remember_me;
      VueCookie.set("login_remember_me", checkbox_remember_me, 30);

      if (!this.checkbox_remember_me) {
        VueCookie.set("login_remember_email", "");
      }
    },
  },
  data() {
    return {
      loginLeftImage: require('@/assets/images/login_left.png'),
      loginTopImage: require('@/assets/images/login_top.svg'),
      hostname: config.HOST_NAME,
      emailInput: "",
      passwordInput: "",
      checkbox_remember_me: false,
      recaptcha: false,
      recaptchaValue: "",
      isLoginInProgress: false, // 로그인 진행중인지 여부
    };
  },
  computed: {
    emailRules() {
      return this.checkEmailRule(this.emailInput);
    },
  },
  created() {
    // 로그인 페이지 진입 시 모든 이미지 설정 로드
    this.loadAllImageConfigs();

    this.checkbox_remember_me = VueCookie.get("login_remember_me") === "true";
    if (this.checkbox_remember_me) {
      this.emailInput = VueCookie.get("login_remember_email") ? VueCookie.get("login_remember_email") : "";
    }
  },
  mounted () {
    UiUtil.loading(false)
  },
  methods: {
    onVerify(r) {
      this.recaptchaValue = r;
      this.recaptcha = true;
    },
    onExpired() {
      this.$refs.recaptcha.reset();
    },

    /**
     * 모든 이미지 설정을 한 번에 로드하는 메서드
     * 로그인 페이지 진입 시 호출되어 localStorage를 업데이트
     * 1. 먼저 localStorage에서 캐시된 이미지를 즉시 로드하여 빠른 UI 렌더링
     * 2. 백그라운드에서 비동기로 API 호출하여 최신 설정으로 업데이트
     */
    async loadAllImageConfigs() {
      // 1. localStorage에서 기존 값들을 즉시 로드하여 적용 (빠른 UI 렌더링)
      this.loadCachedImages();

      // 2. 백그라운드에서 비동기로 API 호출하여 최신 설정으로 업데이트
      try {

        // 병렬로 모든 이미지 설정을 로드
        const [loginLeftConfig, loginTopConfig, sideTopConfig, sideTopStyleConfig] = await Promise.all([
          this.$store.dispatch("keyValue/LOAD_CONFIG", { key: "login_left_image" }),
          this.$store.dispatch("keyValue/LOAD_CONFIG", { key: "login_top_image" }),
          this.$store.dispatch("keyValue/LOAD_CONFIG", { key: "side_top_image" }),
          this.$store.dispatch("keyValue/LOAD_CONFIG", { key: "side_top_image_style" })
        ]);

        // 로그인 관련 이미지들을 localStorage에 저장 및 UI 업데이트
        if (loginLeftConfig && loginLeftConfig.path) {
          localStorage.setItem(`${this.hostname}_login_left_image`, loginLeftConfig.path);
          this.loginLeftImage = loginLeftConfig.path;
          console.log('로그인 왼쪽 이미지 업데이트:', loginLeftConfig.path);
        }

        if (loginTopConfig && loginTopConfig.path) {
          localStorage.setItem(`${this.hostname}_login_top_image`, loginTopConfig.path);
          this.loginTopImage = loginTopConfig.path;
          console.log('로그인 상단 이미지 업데이트:', loginTopConfig.path);
        }

        // 네비게이션바 관련 이미지들도 미리 저장 (다른 페이지에서 API 호출 방지)
        if (sideTopConfig && sideTopConfig.path) {
          localStorage.setItem(`${this.hostname}_side_top_image`, sideTopConfig.path);
          console.log('사이드 상단 이미지 저장:', sideTopConfig.path);
        }

        if (sideTopStyleConfig) {
          localStorage.setItem(`${this.hostname}_side_top_image_style`, JSON.stringify(sideTopStyleConfig));
          console.log('사이드 상단 이미지 스타일 저장:', sideTopStyleConfig);
        }

        console.log('모든 이미지 설정 업데이트 완료');
      } catch (error) {
        console.error('이미지 설정 로드 중 오류:', error);
        // API 오류 시에도 localStorage의 기존 이미지를 계속 사용
      }
    },

    /**
     * localStorage에서 캐시된 이미지들을 즉시 로드
     * 페이지 로딩 속도 향상을 위해 API 호출 전에 먼저 실행
     */
    loadCachedImages() {
      // 로그인 왼쪽 이미지
      const cachedLeftImage = localStorage.getItem(`${this.hostname}_login_left_image`);
      if (cachedLeftImage) {
        this.loginLeftImage = cachedLeftImage;
        console.log('캐시된 로그인 왼쪽 이미지 로드:', cachedLeftImage);
      }

      // 로그인 상단 이미지
      const cachedTopImage = localStorage.getItem(`${this.hostname}_login_top_image`);
      if (cachedTopImage) {
        this.loginTopImage = cachedTopImage;
        console.log('캐시된 로그인 상단 이미지 로드:', cachedTopImage);
      }
    },

    /**
     * 로그인 성공 시 회원 정보를 강제로 갱신하는 메서드
     * 24시간 캐싱 전략에서 로그인 시에만 최신 정보를 가져오기 위함
     */
    async refreshMemberDetailOnLogin() {
      try {
        console.log('로그인 성공 - 회원 정보 강제 갱신 시작');

        // 기존 회원 정보 캐시 삭제
        const projectId = undefined; // 현재 프로젝트 ID가 없으므로 undefined
        const cacheKey = `member_detail_${projectId}`;
        const cacheTimestampKey = `${cacheKey}_timestamp`;

        localStorage.removeItem(cacheKey);
        localStorage.removeItem(cacheTimestampKey);
        console.log('기존 회원 정보 캐시 삭제 완료');

        // 강제 갱신 플래그와 함께 회원 정보 로드
        await this.$store.dispatch('member/LOAD_MEMBER_DETAIL', {
          forceRefresh: true
        });

        console.log('로그인 성공 - 회원 정보 강제 갱신 완료');
      } catch (error) {
        console.error('회원 정보 강제 갱신 중 오류:', error);
        throw error; // 에러를 다시 던져서 호출자에서 처리할 수 있게 함
      }
    },


    handleChangeRememberMe(/*data*/) {},
    checkEmailRule(v) {
      if (v === "") {
        return true;
      }

      const regExp = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i;
      return !regExp.test(v);
    },

    async login() {
      if (this.isLoginInProgress) return;

      const email = this.emailInput;
      const pw = this.passwordInput;
      const rcv = this.recaptchaValue;

      if (!email) {
        alert("아이디를 입력해주세요");
        return;
      }
      if (email.length < 3) {
        alert("아이디는 3글자 이상이어야 합니다.");
        return;
      }

      if (!pw) {
        alert("비밀번호를 입력해주세요");
        return;
      }

      // 비밀번호가 8자 이상, 소문자, 대문자, 숫자가 포함되어있는지 검증
      // if (!/^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9]).{8,255}$/.test(pw)) {
      //   alert("비밀번호는 8자 이상, 소문자, 대문자, 숫자가 포함되어야 합니다.");
      //   return;
      // }

      this.isLoginInProgress = true;

      this.$store
        .dispatch("LOGIN", {
          email,
          pw,
          rcv,
        })
        .then(() => {
          if (VueCookie.get("login_remember_me") === "true") {
            VueCookie.set("login_remember_email", this.emailInput, 30);
          }

          localStorage.setItem("login_username", email);

          // 프로젝트 개수만큼 삭제해야함.
          // 지금은 임의로 10개 삭제하도록 설정
          for (let i = 0; i < 10; i++) {
            localStorage.removeItem(`${email}_${i + 1}_boardIds`);
          }
          localStorage.removeItem("/api/auth/me");
          localStorage.removeItem("/api/v1/member/all");
          localStorage.removeItem("sub_company");

          // 로그인 성공 시 회원 정보 강제 갱신
          this.refreshMemberDetailOnLogin().then(() => {
            const toFullPath = VueCookie.get("LOGIN_TO_FULLPATH");
            if (toFullPath) {
              this.$router.replace(toFullPath).then((value) => {
                VueCookie.delete("LOGIN_TO_FULLPATH"); // 로그인 후 이동할 페이지 삭제
                this.$router.go(0);
              });
            } else {
              this.$router.replace("/home").then((value) => {
                this.$router.go(0);
              });
            }
          }).catch((error) => {
            console.error('회원 정보 갱신 실패:', error);
            // 회원 정보 갱신 실패해도 로그인은 계속 진행
            const toFullPath = VueCookie.get("LOGIN_TO_FULLPATH");
            if (toFullPath) {
              this.$router.replace(toFullPath).then((value) => {
                VueCookie.delete("LOGIN_TO_FULLPATH");
                this.$router.go(0);
              });
            } else {
              this.$router.replace("/home").then((value) => {
                this.$router.go(0);
              });
            }
          });
        })
        .catch((err) => {
          if (this.recaptcha) {
            this.$refs.recaptcha.reset();
          }

          switch (constant.getErrorCode(err)) {
          case constant.ERROR_LOGIN_ID_NULL:
            alert("아이디를 입력해주세요");
            break;
          case constant.ERROR_LOGIN_PASSWORD_NULL:
            alert("비밀번호를 입력해주세요");
            break;
          case constant.ERROR_LOGIN_INVALID_CREDENTIALS:
            alert("아이디 또는 패스워드가 틀립니다");
            break;
          case constant.ERROR_LOGIN_INVALID_RECAPTCHA:
            this.recaptcha = true;
            break;
          case -1:
            switch (err.response.data) {
            case "The login must be between 2 and 255 characters.":
              alert("아이디는 2자 이상 255자 이하로 입력해주세요.");
              break;
            case "The password must be between 4 and 255 characters.":
              alert("비밀번호는 4자 이상 255자 이하로 입력해주세요.");
              break;
            default:
              alert(err.response.data);
              break;
            }
            break;
          }
          this.isLoginInProgress = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1;
    }

    .bg-twitter {
      background-color: #00aaff;
    }

    .bg-google {
      background-color: #4285f4;
    }

    .bg-github {
      background-color: #333;
    }
  }
}
.input-font::v-deep {
  span {
    font-size: 16px !important;
    height: 100%;
  }
  input {
    font-size: 16px !important;
  }
}
.in-bg-img {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background: linear-gradient(rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1)), url("~@/assets/images/pages/vuexy-login-bg.jpg");
}

@media print, screen and (max-width: theme("screens.xl")) {
  .vx-col {
    width: 95%;
  }

  .lt-postion-logo {
    display: none;
  }
}
</style>
